import React from 'react';
import PropTypes from 'prop-types';
import SavedPayment from './children/SavedPayment/SavedPayment';
import NewPayment from './children/NewPayment/NewPayment';

const Payment = props => (
  <div className='row equal Payment'>
    {props.onFileOption ?
      <SavedPayment
        user={props.user}
        submitPayment={props.submitSavedPayment}
        cancelAction={props.cancelPurchase}
        disableButtonsWhileLoading={props.disableButtonsWhileLoading}
        validateTermsChecked={props.validateTermsChecked}
        dispatch={props.dispatch}
      /> :
      <NewPayment
        braintreeSubmitButtonDisabled={props.braintreeSubmitButtonDisabled}
        hostedFields={props.hostedFields}
        hostedFieldsDidCreate={props.hostedFieldsDidCreate}
        user={props.user}
        updateProfile={props.updateProfile}
        braintreeClientToken={props.braintreeClientToken}
        submitPayment={props.submitNewPayment}
        cancelAction={props.cancelPurchase}
        toast={props.toast}
        disableButtonsWhileLoading={props.disableButtonsWhileLoading}
        validateTermsChecked={props.validateTermsChecked}
        dispatch={props.dispatch}
      />
    }
  </div>
);

Payment.propTypes = {
  braintreeSubmitButtonDisabled: PropTypes.bool,
  hostedFields: PropTypes.object,
  hostedFieldsDidCreate: PropTypes.func,
  onFileOption: PropTypes.bool,
  user: PropTypes.object.isRequired,
  updateProfile: PropTypes.func.isRequired,
  braintreeClientToken: PropTypes.string,
  submitSavedPayment: PropTypes.func.isRequired,
  submitNewPayment: PropTypes.func.isRequired,
  cancelPurchase: PropTypes.func.isRequired,
  toast: PropTypes.object.isRequired,
  disableButtonsWhileLoading: PropTypes.bool,
  validateTermsChecked: PropTypes.func,
  dispatch: PropTypes.func,
};

export default Payment;



// WEBPACK FOOTER //
// ./modules/DataExports/components/PurchaseData/children/Payment/Payment.js